<template>
  <v-app class="futuristic-app">

    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-alert-octagon-outline </v-icon>
          </div>

          <div>
            <div class="header-info-title">Info Bencana</div>
            <div class="header-info-subtitle">Data arsip kebencanaan</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container
        class="mt-6 mx-auto content-layer"
        style="max-width: 1200px; position: relative; z-index: 5"
      >
        <v-row>
          <v-col cols="12" lg="5" class="pa-2">
            <v-card class="info-summary-card mb-4 pa-4 overflow-hidden">
              <div class="d-flex align-center">
                <v-avatar
                  color="rgba(1, 140, 116, 0.2)"
                  size="45"
                  class="mr-4 border-primary"
                >
                  <v-icon color="#018c74">mdi-calendar-text</v-icon>
                </v-avatar>
                <div>
                  <div class="gold--text text-overline">TOTAL_ARSIP</div>
                  <div class="white--text text-h6 font-weight-black">
                    {{ bencanaList.length }} PERIODE
                  </div>
                </div>
              </div>
            </v-card>

            <div class="list-control-panel flex-grow-1">
              <div class="d-flex align-center mb-3 px-2">
                <div class="line-decorator-gold mr-3"></div>
                <h2 class="white--text text-overline letter-spacing-2">DATA_INDEX</h2>
              </div>

              <div class="table-body-container scrollable-table">
                <div v-for="item in bencanaList" :key="item.id" class="table-row-wrapper">
                  <v-card
                    class="tenant-row-card"
                    flat
                    tile
                    @click="setActiveBencana(item)"
                  >
                    <v-row no-gutters align="center" class="pa-3">
                      <v-col cols="auto">
                        <div class="icon-hexagon-small">
                          <v-icon small color="#018c74">mdi-history</v-icon>
                        </div>
                      </v-col>
                      <v-col class="px-4">
                        <div
                          class="white--text font-weight-black text-subtitle-2 uppercase text-truncate"
                        >
                          {{ item.periode }}
                        </div>
                        <div
                          class="gold--text opacity-6"
                          style="font-size: 0.6rem; letter-spacing: 1px"
                        >
                          ID_{{ String(item.id).padStart(3, "0") }}
                        </div>
                      </v-col>
                      <v-col cols="auto">
                        <v-icon small color="#018c74" class="opacity-5"
                          >mdi-chevron-right</v-icon
                        >
                      </v-col>
                    </v-row>
                    <div class="row-hover-effect"></div>
                  </v-card>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" lg="7" class="pa-2">
            <v-card class="map-cyber-panel overflow-hidden">
              <div class="map-ui-frame">
                <div class="frame-edge top-left"></div>
                <div class="frame-edge top-right"></div>
                <div class="frame-edge bottom-left"></div>
                <div class="frame-edge bottom-right"></div>
              </div>

              <transition name="fade" mode="out-in">
                <div
                  v-if="activeBencana"
                  :key="activeBencana.id"
                  class="detail-content-scroll pa-6"
                >
                  <div
                    class="text-h4 font-weight-black white--text mb-4 letter-spacing-1"
                  >
                    {{ activeBencana.periode.toUpperCase() }}
                  </div>

                  <v-card
                    flat
                    color="transparent"
                    class="mb-6 rounded-xl overflow-hidden border-primary cyber-photo-container"
                    @click="dialogZoom = true"
                  >
                    <v-img
                      :src="activeBencana.full_url"
                      class="cyber-bencana-photo"
                      contain
                      position="center center"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular
                            indeterminate
                            color="#018c74"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <div class="zoom-hint">
                      <v-icon color="white">mdi-magnify-plus-outline</v-icon>
                    </div>
                  </v-card>

                  <div
                    class="white--text text-body-1 text-justify deskripsi-text"
                    style="white-space: pre-line; line-height: 1.8"
                  >
                    {{ activeBencana.deskripsi }}
                  </div>
                </div>

                <div
                  v-else
                  class="fill-height d-flex align-center justify-center flex-column pa-10 text-center"
                >
                  <v-icon size="80" color="rgba(1, 140, 116, 0.3)" class="mb-4"
                    >mdi-file-find-outline</v-icon
                  >
                  <div class="gold--text letter-spacing-2 text-overline">
                    SYSTEM_READY
                  </div>
                  <div class="white--text text-h6 font-weight-bold">
                    PILIH PERIODE DI SAMPING
                  </div>
                </div>
              </transition>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-dialog
      v-model="dialogZoom"
      max-width="90%"
      content-class="cyber-zoom-dialog"
      overlay-color="#000"
      overlay-opacity="0.9"
    >
      <v-card color="transparent" flat class="position-relative">
        <v-btn icon color="white" class="close-zoom-btn" @click="dialogZoom = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>

        <v-img
          v-if="activeBencana"
          :src="activeBencana.full_url"
          max-height="90vh"
          contain
          class="rounded-lg"
        ></v-img>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import { getInfoBencana } from "@/api/androidInitApi";

export default {
  data: () => ({
    bencanaList: [],
    activeBencana: null,
    dialogZoom: false,
    particles: [],
    ctx: null,
    animationId: null,
  }),
  async mounted() {
    this.initParticles();
    window.addEventListener("resize", this.resizeCanvas);

    try {
      this.bencanaList = (await getInfoBencana()) || [];

      if (this.bencanaList.length > 0) {
        this.activeBencana = this.bencanaList[0];
      }
    } catch (e) {
      console.error("API Error", e);
    }
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationId);
    window.removeEventListener("resize", this.resizeCanvas);
  },
  methods: {
    setActiveBencana(item) {
      this.activeBencana = item;
      this.$nextTick(() => {
        const container = this.$el.querySelector(".detail-content-scroll");
        if (container) container.scrollTop = 0;
      });
    },
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      this.ctx = canvas.getContext("2d");
      this.resizeCanvas();
      this.particles = Array.from({ length: 50 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.25,
        vy: (Math.random() - 0.5) * 0.25,
        radius: Math.random() * 1.5 + 1,
      }));
      this.animate();
    },
    resizeCanvas() {
      const canvas = this.$refs.particleCanvas;
      if (canvas) {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    },
    animate() {
      if (!this.ctx) return;
      this.ctx.clearRect(
        0,
        0,
        this.$refs.particleCanvas.width,
        this.$refs.particleCanvas.height
      );
      this.particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > this.$refs.particleCanvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > this.$refs.particleCanvas.height) p.vy *= -1;
        this.ctx.beginPath();
        this.ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        this.ctx.fillStyle = "rgba(1, 140, 116, 0.25)";
        this.ctx.fill();
      });
      this.animationId = requestAnimationFrame(this.animate);
    },
  },
};
</script>

<style scoped>
.letter-spacing-1 {
  letter-spacing: 1px !important;
}
.letter-spacing-2 {
  letter-spacing: 2px !important;
}
.text-justify {
  text-align: justify;
}


.border-gold-thin {
  border: 1px solid rgba(207, 162, 45, 0.3) !important;
}
.line-decorator-gold {
  width: 4px;
  height: 20px;
  background: #cfa22d;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(207, 162, 45, 0.5);
}

.map-cyber-panel {
  height: calc(100vh - 180px) !important;
  background: rgba(0, 8, 7, 0.8) !important;
  backdrop-filter: blur(10px);
  border-radius: 24px !important;
  border: 1px solid rgba(1, 140, 116, 0.2) !important;
  position: relative;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5) !important;
}

.detail-content-scroll {
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(1, 140, 116, 0.3) transparent;
}
.detail-content-scroll::-webkit-scrollbar {
  width: 4px;
}
.detail-content-scroll::-webkit-scrollbar-thumb {
  background: rgba(1, 140, 116, 0.3);
  border-radius: 4px;
}

.map-ui-frame .frame-edge {
  position: absolute;
  width: 15px;
  height: 15px;
  border: 2px solid #018c74;
  z-index: 10;
  pointer-events: none;
}
.top-left {
  top: 15px;
  left: 15px;
  border-right: none;
  border-bottom: none;
}
.top-right {
  top: 15px;
  right: 15px;
  border-left: none;
  border-bottom: none;
}
.bottom-left {
  bottom: 15px;
  left: 15px;
  border-right: none;
  border-top: none;
}
.bottom-right {
  bottom: 15px;
  right: 15px;
  border-left: none;
  border-top: none;
}

.cyber-photo-container {
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-width: 2px !important;
}
.cyber-photo-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(1, 140, 116, 0.3) !important;
}
.cyber-bencana-photo {
  width: 100%;
  max-height: 400px;
  background: rgba(0, 0, 0, 0.2);
}
.zoom-hint {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px;
  border-radius: 50%;
  backdrop-filter: blur(5px);
  opacity: 0;
  transition: 0.3s;
}
.cyber-photo-container:hover .zoom-hint {
  opacity: 1;
}

.deskripsi-text {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  opacity: 0.9;
  letter-spacing: 0.5px;
}

.info-summary-card {
  background: rgba(107, 106, 106, 0.15) !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  border-radius: 16px !important;
}
.border-primary {
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.table-body-container {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(0, 0, 0, 0.2);
  max-height: calc(100vh - 400px);
  overflow-y: auto;
  scrollbar-width: none;
}
.table-body-container::-webkit-scrollbar {
  width: 0;
}
.table-row-wrapper {
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}
.tenant-row-card {
  background: transparent !important;
  cursor: pointer;
  transition: 0.2s;
  position: relative;
}
.tenant-row-card:hover {
  background: rgba(1, 140, 116, 0.08) !important;
}
.icon-hexagon-small {
  background: rgba(1, 140, 116, 0.1);
  padding: 8px;
  border-radius: 8px;
  border: 1px solid rgba(1, 140, 116, 0.2);
}
.gold--text {
  color: #cfa22d !important;
}
.row-hover-effect {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #cfa22d;
  opacity: 0;
  transition: 0.3s;
  box-shadow: 0 0 10px #cfa22d;
}
.tenant-row-card:hover .row-hover-effect {
  opacity: 1;
}

::v-deep .cyber-zoom-dialog {
  box-shadow: none !important;
  background: transparent !important;
}
.close-zoom-btn {
  position: absolute;
  top: -40px;
  right: -10px;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5) !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}


.futuristic-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 100 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
